let timesheetEntryCounter = 0;

export function getNextTimesheetEntryCounter(): number {
    return timesheetEntryCounter++;
}
